module.exports = __webpack_public_path__ + "static/media/Inverter-and-Stabilizer.37cc1955.jpg";